export const FILTER_TYPES = {
  RECOMMENDED: 'Recommended Batches',
  STARTING_SOON: 'Starting Soon',
  NEW_BATCHES: 'New Batches',
  FAST_FILLING: 'Fast Filling',
  ONGOING: 'Ongoing',
} as const;

export const SELECTION_OPTIONS = {
  WAITLIST: 'waitlist',
} as const;

export const filterMetaData: ReadonlyArray<{
  filterName: string;
  tagDetails: {
    color: string;
    name: string;
    text: string;
  };
}> = [
  {
    filterName: FILTER_TYPES.RECOMMENDED,
    tagDetails: {
      color: 'none',
      name: FILTER_TYPES.RECOMMENDED,
      text: FILTER_TYPES.RECOMMENDED,
    },
  },
  {
    filterName: FILTER_TYPES.STARTING_SOON,
    tagDetails: {
      color: 'var(--color-nirvana-jewel)',
      name: FILTER_TYPES.STARTING_SOON,
      text: FILTER_TYPES.STARTING_SOON,
    },
  },
  {
    filterName: FILTER_TYPES.NEW_BATCHES,
    tagDetails: {
      color: 'var(--color-underwater-fern-green-dark)',
      name: FILTER_TYPES.NEW_BATCHES,
      text: 'New',
    },
  },
  {
    filterName: FILTER_TYPES.FAST_FILLING,
    tagDetails: {
      color: 'var(--color-deep-river-dark)',
      name: FILTER_TYPES.FAST_FILLING,
      text: FILTER_TYPES.FAST_FILLING,
    },
  },
  {
    filterName: FILTER_TYPES.ONGOING,
    tagDetails: {
      color: 'var(--color-cold-lips-dark)',
      name: FILTER_TYPES.ONGOING,
      text: '💸 Get US$50 voucher',
    },
  },
] as const;
